import {
  FormSchema,
  IFormSchemaV2,
  FormData,
  IFormSchema,
} from "@graffer-inc/form-schema";

export class SurveyFormSchema extends FormSchema {
  constructor(values: IFormSchemaV2) {
    super(values);
  }

  initialSectionIndex(formData: FormData): number | null {
    return this.nextSectionIndex(-1, formData);
  }

  nextSectionIndex(sectIndex: number, formData: FormData): number | null {
    const nextSect = sectIndex + 1;
    if (nextSect > this.root.length - 1) {
      return null;
    }
    if (this.isAllHiddenSection(nextSect, formData)) {
      return this.nextSectionIndex(nextSect, formData);
    }
    return nextSect;
  }

  prevSectionIndex(sectIndex: number, formData: FormData): number | null {
    const prevSect = sectIndex - 1;
    if (prevSect < 0) {
      return null;
    }
    if (this.isAllHiddenSection(prevSect, formData)) {
      return this.prevSectionIndex(prevSect, formData);
    }
    return prevSect;
  }

  private isAllHiddenSection(sectIndex: number, formData: FormData) {
    return this.root[sectIndex]
      .applyRules(this.filterApplyingRule(formData))
      .flatten()
      .every((e) => {
        return e.hidden;
      });
  }

  static fromJSON(sc: IFormSchema): SurveyFormSchema {
    return new SurveyFormSchema(FormSchema.fromJSON(sc));
  }
}
